export default __webpack_public_path__ + "static/media/paypal.76bf3519.svg";